import { render, staticRenderFns } from "./ParametersSetting.vue?vue&type=template&id=1f27dd89&scoped=true"
import script from "./ParametersSetting.vue?vue&type=script&lang=js"
export * from "./ParametersSetting.vue?vue&type=script&lang=js"
import style0 from "./ParametersSetting.vue?vue&type=style&index=0&id=1f27dd89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f27dd89",
  null
  
)

export default component.exports